import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SharedService } from '../Shared/Shared.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    private http: HttpClient,
    private sharedService: SharedService,
    private jwtHelperService: JwtHelperService
  ) { }

  login(data){       
    localStorage.setItem('CommentCount', "0");    
    return this.http.post(environment.apiURL + `user/Signin`, data);
  }

  SignOut(data){
    return this.http.post(environment.apiURL + `user/SignOut`, data);
  }
  ForgotPassword(data){
    return this.http.post(environment.apiURL + `email/Send`, data);
  }

  GetUser(email) {
      return this.http.get(environment.apiURL + `user/GetUsers?EmailAddress=` + email + `&Isactive=true`);    
  }

  //Method to check role and having valid token
  public isAuthenticated(allowedRoles: number[]): boolean{

    // console.log('isAuthenticated = ' + this.sharedService.getUserDetail('RoleId'));

    // check if the list of allowed roles is empty, if empty, authorize the user to access the page
    if (allowedRoles == null || allowedRoles.length === 0) {
      return true;
    }
    
    // get token, role from local storage or state management
    const token = this.sharedService.getUserDetail('XauthToken');
    var roleId:number = this.sharedService.getUserDetail('RoleId');

    // decode token to read the payload details
    const decodeToken = this.jwtHelperService.isTokenExpired(token);
    // console.log('isAuthenticated  = ' + decodeToken);
    // check if it was decoded successfully, if not the token is not valid, deny access
    if (decodeToken) {
      console.log('Invalid token');
      return false;
    }
    // console.log(roleId + ' => ' + allowedRoles);
    // console.log(allowedRoles.includes(roleId));
    // check if the user roles is in the list of allowed roles, return true if allowed and false if not allowed
    //return allowedRoles.includes(decodeToken['role']);
    return allowedRoles.includes(Number(roleId));
    //return true;

  }
}
